<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em !important;">Introducing a crusty old codger with a twisted sense of humour, as displayed in the twenty-odd books written by him, some for children; also, hysterically historical tales, others spooky, a few of them gruesome but usually offbeat.</p><br/>
<p style="text-indent:0em !important;">He is a fit eighty-one-year-old, with a beautiful wife whom he has courted from age sixteen, four adult children, twelve grandchildren and three great-grandchildren. Not forgetting his sister, Pam, whom he loves dearly, and her family. Then there’s Pet’s brother, Tony, his wife, Carol and their large family. When they all get together, it’s a real circus. He loves sport and has played cricket, rugby, tennis, hockey, football, squash, golf, table-tennis, is keen on fishing and car-rallied for many years. But now he’s getting too stiff to tie his shoelaces and finds pleasure in pounding the story-telling keyboard.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?39761dbf